import {call, put} from "redux-saga/effects";
import {setProfileSettingsFailure} from "store/reducer/user/settings/reducer";
import * as api from "services/api";

export function* setProfileSettingsSaga({payload}) {
    const {key, value} = payload;
    try {
        yield call([api, api.setProfileSettings], key, value);
    } catch (e) {
        yield put(setProfileSettingsFailure({key, value: !value}));
    }
}